export const getFormattedNumber = ({
  number,
  options = { maximumFractionDigits: 8 },
}) => Intl.NumberFormat('uk-UA', options).format(number)?.replace(/,/g, '.');

export function formatNumber(num) {
  // Перетворюємо число в рядок, замінюємо кому на крапку
  const str = num.toString().replace(',', '.');

  // Якщо немає дробової частини, повертаємо число без змін
  if (!str.includes('.')) return str;

  // Розділяємо на цілу і дробову частини
  const [integerPart, decimalPart] = str.split('.');

  const formattedDecimal = decimalPart.slice(0, integerPart !== '0' ? 2 : 8);

  // Склеїли назад
  return `${integerPart}.${formattedDecimal}`;
}

export function capitalizeFirstLetter(str) {
  if (!str) return str;

  return str.slice(0, 1).toUpperCase() + str.slice(1);
}

export function formatCompactParts(number, locale = 'uk') {
  if (number < 1) {
    return {
      numberPart: new Intl.NumberFormat(locale, {
        maximumFractionDigits: 3,
      }).format(number),
      suffix: '',
    };
  }

  const formatted = new Intl.NumberFormat(locale, {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(number);

  const [numberPart, suffix = ''] = formatted
    .replace(/\u00A0/g, ' ')
    .split(' ');

  return { numberPart, suffix };
}

export const formatCompactNumber = (value, locale = 'uk') =>
  new Intl.NumberFormat(locale, {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(value);
